/* ============
 * State of the auth module
 * ============
 *
 * The initial state of the auth module.
 */

import { getUrlLang } from '@/plugins/common'

export default {
  language: getUrlLang(),
  api: []
}
